"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DECIMAL_SEPARATOR = void 0;
// (C) 2022 GoodData Corporation
exports.DEFAULT_DECIMAL_SEPARATOR = ".";
//# sourceMappingURL=format.js.map